(() => {
  const validWindow = (config, now) => {
    const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/;
    if (!config.enabled || !config.collection || !config.campaign || !Number.isInteger(config.percent) || config.percent < 1 || config.percent > 90 || !iso.test(config.start) || !iso.test(config.end)) return false;
    const realDate = value => {
      const [year, month, day, hour, minute, second] = value.slice(0, 19).split(/[-T:]/).map(Number);
      const date = new Date(Date.UTC(year, month - 1, day));
      return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day && hour < 24 && minute < 60 && second < 60;
    };
    if (!realDate(config.start) || !realDate(config.end)) return false;
    const start = Date.parse(config.start), end = Date.parse(config.end);
    return Number.isFinite(start) && Number.isFinite(end) && start < end && now >= start && now < end;
  };
  const remainingLabel = (config, now) => {
    if (!validWindow(config, now)) return '';
    const remaining = Date.parse(config.end) - now;
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const unit = (value, name) => `${value} ${name}${value === 1 ? '' : 'S'}`;
    if (days) return `${unit(days, 'DAY')}${hours ? ` ${unit(hours, 'HOUR')}` : ''} LEFT!`;
    if (hours) return `${unit(hours, 'HOUR')}${minutes ? ` ${unit(minutes, 'MINUTE')}` : ''} LEFT!`;
    if (minutes) return `${unit(minutes, 'MINUTE')} LEFT!`;
    return 'ENDS IN LESS THAN A MINUTE!';
  };
  if (typeof module !== 'undefined') module.exports = { validWindow, remainingLabel };
  if (typeof document === 'undefined') return;
  let config;
  try { config = JSON.parse(document.getElementById('mccga-sale-settings').textContent); } catch { return; }
  const dialog = document.getElementById('mccga-sale-dialog');
  const active = () => validWindow(config, Date.now());
  window.mccgaSalePopupActive = () => active() && config.popup && typeof dialog?.showModal === 'function';
  let previousFocus;
  const key = `mccga-sale:${config.campaign}`;
  let seen = false;
  try { seen = localStorage.getItem(key) === 'seen'; } catch { }
  const remember = () => {
    seen = true;
    try { localStorage.setItem(key, 'seen'); } catch { }
  };
  const close = () => { dialog.close(); previousFocus?.focus(); remember(); };
  dialog?.querySelectorAll('[data-sale-close]').forEach(button => button.addEventListener('click', close));
  dialog?.addEventListener('cancel', () => { remember(); });
  dialog?.addEventListener('close', () => { previousFocus?.focus(); });
  const render = () => {
    const now = Date.now();
    const show = validWindow(config, now);
    const countdown = dialog?.querySelector('[data-sale-countdown]');
    const label = remainingLabel(config, now);
    if (countdown && countdown.textContent !== label) countdown.textContent = label;
    document.querySelectorAll('.mccga-sale-image-badge').forEach(badge => { badge.hidden = true; });
    document.querySelectorAll('.mccga-sale-price').forEach(element => {
      element.hidden = !show;
      element.closest('.price').classList.toggle('mccga-sale-active', show);
      const card = element.closest('.product-card-wrapper');
      const image = card?.querySelector?.('.card__media');
      const mount = image?.closest('.card__inner');
      const source = element.querySelector?.('.mccga-sale-badge');
      if (mount && source) {
        let badge = mount.querySelector('.mccga-sale-image-badge');
        if (!badge && show) {
          badge = source.cloneNode(true);
          badge.classList.add('mccga-sale-image-badge');
          mount.appendChild(badge);
        }
        if (badge) badge.hidden = !show;
      }
    });
    document.querySelectorAll('.mccga-sale-notice').forEach(element => { element.hidden = !show; });
    if (!show && dialog?.open) dialog.close();
  };
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) render();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  render();
  setInterval(render, 1000);
  document.addEventListener('visibilitychange', render);
  setTimeout(() => {
    if (!seen && window.mccgaSalePopupActive() && !document.querySelector('dialog[open]')) {
      previousFocus = document.activeElement;
      dialog.showModal();
      dialog.querySelector('[data-sale-close]').focus();
      remember();
    }
  }, 1500);
})();
